 export const companyCodes = {
 
      "Vella": "VE",
      "98 Acres": "98",
      "Ravana Pool Club": "RPC",
      "Flying Ravana": "FR",
      "Le Maas Tota": "LMT",
      "Tea Factory": "TF",
      "Walaa kulu": "WK",
      "Kiri Kopi": "KK",
      "Halpe Tea": "HT",
      "Ambuluwawa Swing": "AS",
      "Ella Swing": "ES",
      "Lucha Lucha": "LL",
      "UHE Plantation": "UHEP",
      "UHE Exports": "UHEE",
      "UVA Halpewatte": "UVAH",
    };